import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export function SectionLabel({ children, dark }) {
  return (
    <span style={{
      display: 'inline-block',
      color: dark ? 'var(--yellow)' : 'var(--yellow)',
      fontSize: 28, fontWeight: 800, letterSpacing: '2.5px',
      textTransform: 'uppercase', marginBottom: 14,
      background: dark ? 'rgba(245,197,24,0.12)' : 'rgba(11,31,74,0.07)',
      padding: '5px 14px', borderRadius: 999,
    }}>
      {children}
    </span>
  );
}

export function SectionTitle({ children, style }) {
  return (
    <h2 style={{
      color: 'var(--navy)',
      lineHeight: 1.08, maxWidth: 640, ...style,
      fontSize: 'clamp(42px, 5vw, 58px)',
    }}>{children}</h2>
  );
}

export function SectionSub({ children, style }) {
  return (
    <p style={{
      fontSize: 17, color: 'var(--gray)',
      maxWidth: 560, marginTop: 16, lineHeight: 1.75, ...style,
    }}>{children}</p>
  );
}

export function RevealBox({ children, delay = 0, style }) {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
      style={style}
    >
      {children}
    </motion.div>
  );
}

export function BtnPrimary({ href, children, onClick }) {
  return (
    <a href={href} onClick={onClick} style={{
      background: 'var(--yellow)', color: 'var(--navy)',
      padding: '14px 30px', borderRadius: 10, fontWeight: 700, fontSize: 15,
      display: 'inline-flex', alignItems: 'center', gap: 8, transition: 'all 0.25s',
      border: 'none', cursor: 'pointer', fontFamily: 'DM Sans,sans-serif',
    }}
    onMouseEnter={e => { e.currentTarget.style.background='var(--yellow2)'; e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 10px 30px rgba(245,197,24,0.3)'; }}
    onMouseLeave={e => { e.currentTarget.style.background='var(--yellow)'; e.currentTarget.style.transform='translateY(0)'; e.currentTarget.style.boxShadow='none'; }}
    >{children}</a>
  );
}